import AddProductMasterDialogOrig from "../../../../components/dialog/addProductMasterDialog/AddProductMasterDialog";

export default function AddProductMasterDialog ({isOpen, onClose, addingProduct, ...props}) {

  return (
    <AddProductMasterDialogOrig
      open={isOpen}
      onClose={onClose(null)}
      productData={addingProduct}
      openAddProductDialog={(product) => onClose({status: "RETURN_ADD_PRODUCT", product})()}
      openAddProductDetailMasterDialog={(product) => onClose({status: "ADD_PRODUCT_DETAIL_MASTER", product})()}
    />
  )
}